import moment from "moment/moment";
import TableActions from "../../../../../components/Common/TableActions";
import TableLayout from "../../../../../components/TableLayout";
import dataHandler from "../../../../../hooks/dataHandler";
import { SERVICE_CATEGORY_LIST } from "../../../../../services/ApiCalls";
import { removeUnderScoreAndCapitalizeFirstLetter } from "../../../../../utilities/utilities";

const TopCategories = () => {
    const {
        setBody,
        body,
        data,
        loader,
        deleteModel,
        setDeleteModel,
        paginationHandler,
        searchHandler,
        total,
        deleteHandler,
    } = dataHandler({
        api: SERVICE_CATEGORY_LIST,
    });

    const column = [
        {
            head: "Sr. No.",
            accessor: "#",
            component: (item, key) => {
                return <>{body.limit * (body.page - 1) + key + 1}</>;
            },
        },
        { head: "Name", accessor: "catName" },
        {
            head: "Created At",
            accessor: "createdAt",
            component: (item, key, arr) => (
                <>{moment(item.date_created_utc).format("DD-MM-YYYY , HH:MM")}</>
            ),
        },
        {
            head: "Status",
            accessor: "status",
            component: (item, key) => {
                return <p>{removeUnderScoreAndCapitalizeFirstLetter(item.status)}</p>;
            },
        },
        {
            head: "Action",
            accessor: "Action",
            component: (item, key, arr) => {
                console.log(item, "item");
                return (
                    <TableActions
                        viewLink={`/manage-service-category/detail/${item._id}`}
                     
                    />
                );
            },
        },
    ];


    return (
        <TableLayout loader={loader} data={data} column={column} />
    )

}

export default TopCategories;